import { render, staticRenderFns } from "./Category.vue?vue&type=template&id=1c151c1b&"
import script from "./Category.vue?vue&type=script&lang=js&"
export * from "./Category.vue?vue&type=script&lang=js&"
import style0 from "./Category.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* nuxt-component-imports */
installComponents(component, {LoadingOverlay: require('/lasso/components/LoadingOverlay.vue').default,Template: require('/lasso/components/templates/Template.vue').default,IconTrash: require('/lasso/components/icons/IconTrash.vue').default,NotViewed: require('/lasso/components/NotViewed.vue').default})


/* hot reload */
if (module.hot) {
  var api = require("/lasso/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c151c1b')) {
      api.createRecord('1c151c1b', component.options)
    } else {
      api.reload('1c151c1b', component.options)
    }
    module.hot.accept("./Category.vue?vue&type=template&id=1c151c1b&", function () {
      api.rerender('1c151c1b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/questions/Category.vue"
export default component.exports